import * as React from 'react';
import { Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';

interface Props {
    onSelect?: any;
    for_staff?: boolean;
    placeholder?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export const Processes = (props: Props) => {
    return (
        <Select
            size={props?.for_staff ? 'middle' : 'small'}
            dropdownMatchSelectWidth={false}
            bordered={true}
            {...props}
            disabled={props.disabled ? true : false}
        >
            <Select.Option value="CNC">CNC Machining</Select.Option>
            <Select.Option value="3D PRINTING">3D Printing</Select.Option>
            <Select.Option value="Sheet Metal">Sheet Metal</Select.Option>
            <Select.Option value="Injection Molding">Injection Molding</Select.Option>
            <Select.Option value="Forgings">Forgings</Select.Option>
            <Select.Option value="Castings">Castings</Select.Option>
        </Select>
    );
};
